export default () => {
  const removeScrollPointer = () => {
    let counter = 0;
    return (e) => {
      counter += 1;
      if (counter > 2) {
        $(e.currentTarget).addClass('scroll-help-activated');
      }
    };
  };

  $('.scroll-help').on('click touchstart', removeScrollPointer());
};